import React, { createRef, useEffect, useRef } from 'react';
import styles from '../../styles/AgeGroupSelector.module.css';
import Pill from '../Pill';
import { type AgeGroupData } from '../../lib/types';

function AgeGroupSelector(props: {
  ageGroups: AgeGroupData[];
  setCurrentAgeGroup: any;
  currentAgeGroup: number;
}) {
  const container = React.useRef<HTMLDivElement>(null);

  const selectorRefs = useRef<Array<React.RefObject<HTMLDivElement>>>([]);

  useEffect(() => {
    if (selectorRefs.current.length !== props.ageGroups.length) {
      selectorRefs.current = Array.from({ length: props.ageGroups.length })
        .fill(null)
        .map((_, i) => selectorRefs.current[i] || createRef());
    }
  }, [props.ageGroups]);

  const selectors = props.ageGroups.reduce((result: any, ageGroup, index) => {
    const currentAgeGroup = Math.min(selectorRefs.current.length - 1, props.currentAgeGroup);
    if (ageGroup.minMonths && ageGroup.minMonths % 12 === 0 && index !== 0)
      result.push(<div key={index} className={styles.divider} />);
    result.push(
      <span key={ageGroup.displayName} ref={selectorRefs.current[index]}>
        <Pill
          id={`age-${index}`}
          content={ageGroup.displayName || ''}
          variant={
            currentAgeGroup === index
              ? 'ageGroupSelectorActive'
              : 'ageGroupSelector'
          }
          onClick={() => props.setCurrentAgeGroup(index)}
        />
      </span>
    );
    return result;
  }, []);

  const scrollTo = (index: number) => {
    const innerIndex = Math.min(selectorRefs.current.length - 1, index);
    const pill = selectorRefs.current[innerIndex];
    container.current?.scrollTo({
      left:
        (pill.current?.offsetLeft ?? 0) -
        (container.current?.offsetWidth ?? 0) / 2 +
        (pill.current?.offsetWidth ?? 0) / 2,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    scrollTo(props.currentAgeGroup);
  }, [props.currentAgeGroup]);

  return (
    <div
      ref={container}
      className={`${styles.ageGroupSelector} d-flex align-items-center gap-2 py-4`}
    >
      {selectors}
    </div>
  );
}

export default AgeGroupSelector;
